import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLightbulbGray(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 100" {...props}>
      <path
        fill="#D7DEE8"
        d="M10.451 56.356c4.05 4.912 6.11 9.424 7.477 15.541h30.27c.927-5.366 3.64-10.943 7.085-15.125 2.056-2.496 3.826-4.24 5.605-7.04a32.3 32.3 0 0 0 4.36-24.377c-1.831-8.27-7.295-15.722-14.362-20.279-7.54-4.86-17.02-6.164-25.708-4.195A32.7 32.7 0 0 0 4.833 15.614a31.69 31.69 0 0 0 .044 33.71c1.889 2.97 3.444 4.448 5.574 7.032"
      />
      <path
        fill="#7689A6"
        d="M19.435 37.943c-.401 4.36 5.119 6.814 8.709 7.137q.354 9.177.949 18.342c.16 2.602.477 6.133.477 8.475H17.928v2.108h30.27v-2.108H36.592c.028-1.79.197-3.696.306-5.499l.502-8.36c.293-4.256.494-8.674.813-12.886 2.29-.057 4.663-.986 6.376-2.458 5.512-4.736.017-11.317-5.367-6.517-2.012 1.794-2.587 4.67-2.65 7.3a94 94 0 0 1-6.632-.122c-.189-2.508-.556-4.393-2.142-6.43-1.644-2.11-4.713-3.42-7.005-1.52a3.74 3.74 0 0 0-1.36 2.538"
      />
      <path
        fill="#D8DDE4"
        d="M30.061 45.302c1.894.13 4.394.124 6.305.093-.361 2.62-.486 6.356-.695 9.036-.407 5.205-.608 10.518-1.036 15.72-.019.587-.074 1.19-.12 1.775l-3.031.005c-.093-8.604-1.293-18.01-1.423-26.63m-6.898-8.943c3.551.26 4.644 3.856 4.85 6.878l-1.529-.352c-2.184-.653-4.389-1.657-5.033-4.081-.363-1.37.436-2.193 1.712-2.445m19.789.009c2.19.11 2.46 1.926 1.482 3.58-1.008 1.706-2.594 2.435-4.407 2.958l-1.61.386c.228-2.943 1.164-6.353 4.535-6.924"
      />
      <path
        fill="#F7F8F9"
        d="M8.84 27.695c-1.82-1.214-1.9-3.14-1.299-5.111 2.34-7.672 9.198-14.63 17.033-16.481 2.06-.487 4.244-.175 5.42 1.763 1.624 2.746-2.917 5.392-4.853 6.554-5.176 3.108-10.04 7.483-13.442 12.51a1.94 1.94 0 0 1-1.233.819c-.677.233-.968.2-1.627-.054m1.216 3.908c2.859.076 2.9 3.532-.013 4.279-.72-.163-1.098-.16-1.677-.673-.862-.765-1.17-2.033-.342-2.951.628-.695 1.168-.636 2.032-.655"
      />
      <path
        fill="#B4BECD"
        d="M15.833 75.41a1.4 1.4 0 0 1 1.397-1.405h31.2c.772 0 1.397.629 1.397 1.405s-.625 1.405-1.397 1.405h-31.2c-.772 0-1.397-.63-1.397-1.405"
      />
      <path
        fill="#9CA9BD"
        d="M17.936 78.689c0-1.035-.24-1.874-.24-1.874H48.43s-.24.839-.24 1.874c0 1.034.24 1.873.24 1.873H17.696s.24-.839.24-1.873"
      />
      <path
        fill="#B4BECD"
        d="M15.833 81.967a1.4 1.4 0 0 1 1.397-1.405h31.2c.772 0 1.397.63 1.397 1.405a1.4 1.4 0 0 1-1.397 1.405h-31.2a1.4 1.4 0 0 1-1.397-1.405m0 6.558c0-.776.625-1.406 1.397-1.406h31.2c.772 0 1.397.63 1.397 1.406s-.625 1.405-1.397 1.405h-31.2c-.772 0-1.397-.63-1.397-1.405"
      />
      <path
        fill="#9CA9BD"
        d="M17.936 85.246c0-1.035-.24-1.874-.24-1.874H48.43s-.24.84-.24 1.874.24 1.873.24 1.873H17.696s.24-.838.24-1.873m-.24 4.684H48.43S45.17 100 33.063 100 17.696 89.93 17.696 89.93"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLightbulbGray);
export default ForwardRef;
